import { createSlice } from '@reduxjs/toolkit';
import { fetchPermissions } from './accounts.thunk';
import { accountsStoreKey } from './accounts.const';

const accountsSlice = createSlice({
  name: accountsStoreKey,
  initialState: {
    list: [] as { fssId: string; zohoCrmId: string; name: string }[],
    selected: null as string | null,
    loading: true,
    permissions: [] as string[],
  },
  reducers: {
    setSelectedAccount(state, action) {
      state.selected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPermissions.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPermissions.fulfilled, (state, action) => {
        state.loading = false;
        const {
          accountsToAssumeClientRoleFor,
          currentImpersonationFssId,
          permissions,
        } = action.payload;

        state.list = accountsToAssumeClientRoleFor || [];
        state.selected = currentImpersonationFssId || null;
        state.permissions = permissions || [];
      })
      .addCase(fetchPermissions.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setSelectedAccount } = accountsSlice.actions;
export const accountsReducer = accountsSlice.reducer;
